import React from 'react';
import { Box, ScopedCssBaseline } from '@mui/material';
import ABIQuery from '../query-form/ABIQuery';

function TablePage(props) {

  return (
    <ScopedCssBaseline>

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: '1.5rem',
        }}
      >
        <ABIQuery />
      </Box>
    </ScopedCssBaseline>);
};

export default TablePage;